
import { toLocalDateTime } from '@/utils/localDate'
import { REALISATION_ROUTE_NAME } from '@/utils/realisationUrls'
import { LIGHTING_GUIDE_ROUTE } from '@/utils/lightingGuide'

export default {
  name: 'ArticleListItem',
  props: {
    article: Object,
    nameIsH2: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      url: this.getUrl(),
    }
  },

  methods: {
    getDateArticle(created_at, bumped_at, dateFormat) {
      const createdAt = toLocalDateTime(created_at)
      const bumpedAt = toLocalDateTime(bumped_at)
      return this.$options.filters.dateFormat(
        new Date(bumpedAt) > new Date(createdAt) ? bumpedAt : createdAt,
        dateFormat
      )
    },
    getUrl() {
      // Cas spécial pour l'article du comparatif H7 qui a une page dédiée
      if (this.article.slug === 'comparatif-meilleures-ampoules-led-h7') {
        return '/blog-led-accessoires-vehicules/comparatif-meilleures-ampoules-led-h7'
      }

      if (this.article.slug === 'verifier-eclairage-voiture') {
        return { name: LIGHTING_GUIDE_ROUTE }
      }

      if (
        this.article.slug ===
        'meilleures-ampoules-feux-de-croisement-peugeot-2008'
      ) {
        return '/blog-led-accessoires-vehicules/meilleures-ampoules-feux-de-croisement-peugeot-2008'
      }

      if (this.article.article_type_id == 2) {
        return {
          name: 'blog-led-accessoires-vehicules-slug',
          params: { slug: this.article.slug },
        }
      } else {
        return {
          name: REALISATION_ROUTE_NAME,
          params: { slug: this.article.slug },
        }
      }
    },
  },
}
